

import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class WarningService {
    public isShowContractWarning = new BehaviorSubject<any>(null);

    constructor() {}

    ngOnDestroy(): void {}

    setContractWarning(data: any) {
        this.isShowContractWarning.next(data);
    }

    getContractWarning() {
        return this.isShowContractWarning.asObservable();
    }
   
}